module.exports = __webpack_public_path__ + "static/media/13_2.d192b295.png";